import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IconSharedModule } from '../../atoms/icon/icon.module';

import { AddToCalendarSharedComponent } from './add.to.calendar.component';

@NgModule({
    declarations: [
        AddToCalendarSharedComponent
    ],
    imports: [
        CommonModule,
        IconSharedModule
    ],
    exports: [
        AddToCalendarSharedComponent
    ]
})

export class AddToCalendarSharedModule {}
